import React from "react";

export interface IAdminTab<T> {
    value: T;
    label: React.ReactNode;
    count?: number;
    // destaque vermelho (ex.: pendências abertas)
    alert?: boolean;
}

// abas sublinhadas, com rolagem horizontal quando não cabem na largura (mobile)
export default function AdminTabs<T extends string | number>({ tabs, value, onChange, className = "" }: { tabs: IAdminTab<T>[], value: T, onChange: (v: T) => void, className?: string }) {
    return (
        <div role="tablist" className={`flex gap-1 overflow-x-auto -mb-px [scrollbar-width:none] [&::-webkit-scrollbar]:hidden ${className}`}>
            {
                tabs.map(tab => {
                    const active = tab.value === value;
                    return (
                        <button
                            key={String(tab.value)}
                            type="button"
                            role="tab"
                            aria-selected={active}
                            onClick={() => onChange(tab.value)}
                            className={`relative inline-flex items-center gap-2 px-3 py-3 text-sm font-semibold whitespace-nowrap border-b-2 transition-colors focus:outline-none focus-visible:bg-gray-100 ${active ? "border-secondary text-gray-900" : "border-transparent text-gray-500 hover:text-gray-800 hover:border-gray-300"}`}
                        >
                            {tab.label}
                            {
                                tab.count !== undefined ?
                                    <span className={`inline-flex items-center justify-center min-w-[1.25rem] h-5 px-1.5 rounded-full text-[11px] font-bold tabular-nums ${tab.alert ? "bg-red-500 text-white" : active ? "bg-gray-900 text-white" : "bg-gray-100 text-gray-600"}`}>{tab.count}</span>
                                    : tab.alert ?
                                        <span className="h-2 w-2 rounded-full bg-red-500" aria-label="pendente" />
                                        : null
                            }
                        </button>
                    )
                })
            }
        </div>
    )
}

// seletor de opção única em formato de pílulas (substitui grupos de radio)
export function AdminSegmented<T extends string>({ options, value, onChange, className = "" }: { options: { value: T, label: React.ReactNode }[], value: T, onChange: (v: T) => void, className?: string }) {
    return (
        <div role="radiogroup" className={`inline-flex flex-wrap gap-1 rounded-lg bg-gray-100 p-1 ${className}`}>
            {
                options.map(option => {
                    const active = option.value === value;
                    return (
                        <button
                            key={option.value}
                            type="button"
                            role="radio"
                            aria-checked={active}
                            onClick={() => onChange(option.value)}
                            className={`px-3 py-1.5 rounded-md text-sm font-semibold transition focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary ${active ? "bg-white text-gray-900 shadow-sm" : "text-gray-500 hover:text-gray-900"}`}
                        >
                            {option.label}
                        </button>
                    )
                })
            }
        </div>
    )
}
